export class SnRecordingUrls {
  public incident: string;
  public thumbnail: string;

  public expiresAt: Date;

  constructor(data: any) {
    this.incident = data.incident && data.incident.url;
    this.thumbnail = data.thumbnail && data.thumbnail.url;

    const defaultExpiresAt = new Date(Date.now() + 3600000); // 1 hour
    this.expiresAt =
      (data.incident && data.incident.expiresAt && new Date(data.incident.expiresAt)) ||
      defaultExpiresAt;
  }
}
